module.exports = __webpack_public_path__ + "img/spitter-die-3.5626b651.png";